<div class="lum-c-cost-layer-quantity-progress">
  <progress
    class="lum-c-cost-layer-quantity-progress__bar"
    [value]="displayValue"
    [max]="initialQuantity"
    [attr.data-percentage]="progressPercentage"
    [class.lum-c-cost-layer-quantity-progress__bar--depleting]="
      progressPercentage < 100
    "
    [class.lum-c-cost-layer-quantity-progress__bar--full]="
      progressPercentage >= 100
    "
    [class.lum-c-cost-layer-quantity-progress__bar--warning]="
      initialQuantity <= 0 || remainingQuantity < 0
    "
  ></progress>
  <span class="lum-c-cost-layer-quantity-progress__label">
    {{ remainingQuantity | decimalPlaces }}/{{ initialQuantity | decimalPlaces }}
  </span>
</div>
